import { z } from 'zod';

import { dataCollectionResponseSchema } from './common';

// ---------------------------------------------------------------------------
// Enums
// ---------------------------------------------------------------------------

export const NotificationType = {
  CommentReply: 0,
  CommentLike: 1,
  JobApplyReminder: 10,
  InterviewReminder: 11,
  FollowUpReminder: 12,
  ScrapeCompleted: 20,
} as const;

export type NotificationTypeValue =
  (typeof NotificationType)[keyof typeof NotificationType];

// ---------------------------------------------------------------------------
// Notification DTO
// ---------------------------------------------------------------------------

export const notificationDtoSchema = z.object({
  id: z.string().uuid(),
  message: z.string(),
  type: z.string().nullable().optional(),
  typeEnum: z.number(),
  isRead: z.boolean(),
  relatedCommentId: z.string().nullable().optional(),
  actionerUserId: z.string().uuid().nullable().optional(),
  actionerCommentId: z.string().nullable().optional(),
  createdOnUtc: z.string(),
  actionerName: z.string().nullable().optional(),
  actionerProfilePictureUrl: z.string().nullable().optional(),
  originalCommentText: z.string().nullable().optional(),
  actionerCommentText: z.string().nullable().optional(),
  relatedJobId: z.string().uuid().nullable().optional(),
  relatedJobTitle: z.string().nullable().optional(),
  relatedJobCompany: z.string().nullable().optional(),
  relatedRunId: z.string().nullable().optional(),
});

export type NotificationDto = z.infer<typeof notificationDtoSchema>;

// ---------------------------------------------------------------------------
// Response
// ---------------------------------------------------------------------------

export const notificationCollectionResponseSchema = dataCollectionResponseSchema(
  notificationDtoSchema
).extend({
  unreadCount: z.number(),
});

export type NotificationCollectionResponseDto = z.infer<
  typeof notificationCollectionResponseSchema
>;
